import React from "react";

const Card = ({ img, title, text }) => {
  return (
    <div className="card card-skills">
      <img className="card-img-top" src={img} alt={title} />
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p className="status">{text}</p>
      </div>
    </div>
  );
};

export default Card;
